import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from '@chatterbug/aaron'

const SelfAssessmentSkeleton = ({
  sliderSection,
  titleSection,
  explanationSection,
  buttonSection,
  disclaimerTextSection,
}) => {
  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      {sliderSection}
      <Box as="p" variant="text.h5" mt="4x">
        {titleSection}
      </Box>
      <Box as="p" width="100%" mt="2x" textAlign="center" fontSize="xxs">
        {explanationSection}
      </Box>
      <Box mt="3x" width="100%">
        {buttonSection}
      </Box>
      <Box textAlign="center" mt="2x" fontSize="10px" color="gray46">
        {disclaimerTextSection}
      </Box>
    </Flex>
  )
}

SelfAssessmentSkeleton.propTypes = {
  sliderSection: PropTypes.any,
  titleSection: PropTypes.any,
  explanationSection: PropTypes.any,
  buttonSection: PropTypes.any,
  disclaimerTextSection: PropTypes.any,
}

export default SelfAssessmentSkeleton
